import Phaser from 'phaser';
import { COLORS, GAME_WIDTH, GAME_HEIGHT } from '../constants.js';
import { logStage, STAGES } from '../utils/IPLogger.js';

export default class MenuScene extends Phaser.Scene {
  constructor() {
    super({ key: 'MenuScene' });
    this.music = null;
  }

  create() {
    // Log arrival at main screen
    logStage(STAGES.MAIN_SCREEN);

    // Add the title screen background image
    const bg = this.add.image(GAME_WIDTH / 2, GAME_HEIGHT / 2, 'title_screen');

    // Scale to fit entire image within game dimensions (letterbox if needed)
    const scaleX = GAME_WIDTH / bg.width;
    const scaleY = GAME_HEIGHT / bg.height;
    const scale = Math.min(scaleX, scaleY); // Use min to fit entire image
    bg.setScale(scale);

    // Start theme music (if not already playing)
    // Handle browser autoplay policy - audio context may be locked until user interaction
    if (!this.music || !this.music.isPlaying) {
      this.music = this.sound.add('theme_music', {
        loop: true,
        volume: 0.6,
      });

      // Try to play - Phaser handles autoplay policy internally
      try {
        this.music.play();
      } catch (e) {
        // If blocked, will play on first interaction via Phaser's unlock mechanism
        console.log('Audio autoplay blocked, will play on interaction');
      }
    }

    // Blinking "PRESS ENTER OR CLICK TO START" text at bottom
    const startText = this.add.text(GAME_WIDTH / 2, GAME_HEIGHT - 80, 'PRESS ENTER OR CLICK TO START', {
      fontFamily: 'Courier New',
      fontSize: '20px',
      fill: '#ffff00',
      stroke: '#000000',
      strokeThickness: 4,
    });
    startText.setOrigin(0.5);

    // Blink the start text
    this.tweens.add({
      targets: startText,
      alpha: { from: 1, to: 0.3 },
      duration: 500,
      yoyo: true,
      repeat: -1,
    });

    // VHS REC indicator
    const recText = this.add.text(20, 20, 'REC', {
      fontFamily: 'Courier New',
      fontSize: '14px',
      fill: '#ff0000',
      stroke: '#000000',
      strokeThickness: 2,
    });

    const recDot = this.add.circle(50, 27, 5, 0xff0000);
    this.tweens.add({
      targets: [recDot, recText],
      alpha: { from: 1, to: 0 },
      duration: 500,
      yoyo: true,
      repeat: -1,
    });

    // Date overlay
    this.add.text(GAME_WIDTH - 20, 20, '1987-10-31  03:47 AM', {
      fontFamily: 'Courier New',
      fontSize: '14px',
      fill: '#ffffff',
      stroke: '#000000',
      strokeThickness: 2,
    }).setOrigin(1, 0);

    // Version
    this.add.text(GAME_WIDTH - 20, GAME_HEIGHT - 20, 'v0.1.0 - 1v1studios', {
      fontFamily: 'Courier New',
      fontSize: '12px',
      fill: '#888888',
      stroke: '#000000',
      strokeThickness: 2,
    }).setOrigin(1, 1);

    // Input handlers - ENTER or click to start
    this.input.on('pointerdown', () => this.startGame());
    this.input.keyboard.on('keydown-ENTER', () => this.startGame());
  }

  startGame() {
    // Clear event listeners
    this.input.off('pointerdown');
    this.input.keyboard.off('keydown-ENTER');

    // Fade out music
    if (this.music) {
      this.tweens.add({
        targets: this.music,
        volume: 0,
        duration: 500,
      });
    }

    // Fade to black then start cutscene
    this.cameras.main.fadeOut(500, 0, 0, 0);
    this.cameras.main.once('camerafadeoutcomplete', () => {
      if (this.music) {
        this.music.stop();
      }
      this.scene.start('CutsceneScene');
    });
  }
}
